import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import { Util } from '../../../config/Util';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import './Manager.css';

export default class Manager extends Component {
    constructor(){
        super();
        this.columns = [
          {
              name: 'ID',
              selector: row => row.id, 
              center:true,
              grow:0.25
          },
          {
              name: 'NAME',
              selector: row => row.name,
              grow:0.75,
              center:true
          },
          {
            name: 'DEPT',
            selector: props => this.formatDepartment(props.groups),
            center:true,
            grow:0.5
          },
          {
            id:"status",
            center:true,
            name:"COMMUNICATION",
            cell: props => {
              return  <div className='task-status'>
                <span className='task-completed'>{props.communications.completed}</span>
                <span className='task-pending'>{props.communications.pending}</span>
                <span className='task-overdue'>{props.communications.overdue}</span>
              </div> 
                  
             
    
           },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            minWidth:"150px"
          },
          {
            id:"status-train",
            center:true,
            name:"TRAINING",
            cell: props => {
              return  <div className='task-status'>
                <span className='task-completed'>{props.trainings.completed}</span>
                <span className='task-pending'>{props.trainings.pending}</span>
                <span className='task-overdue'>{props.trainings.overdue}</span>
              </div> 
                  
             
    
           },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            minWidth:"150px"
          },
          {
            id:"status-asses",
            center:true,
            name:"ASSESSMENT",
            cell: props => {
              return  <div className='task-status'>
                <span className='task-completed'>{props.assessments.completed}</span>
                <span className='task-pending'>{props.assessments.pending}</span>
                <span className='task-overdue'>{props.assessments.overdue}</span>
              </div> 
                  
             
    
           },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            minWidth:"150px"
          },
          
        
      ]
        this.state = {
          data : [],
          fullData:[],
          loader : false
        }
        
    }
    
   
    componentDidMount(){
      this.loadData();
    }
    
    loadData =()=>{
      this.setState({loader:true});
      axios.post(API.getReportees, {id: Util.userId}).then((res)=>{
        if(res.status === 200 && res.data){
          this.setState({data : res.data.reportees});
        }
        this.setState({loader:false});
        }).catch((er)=>{
          this.setState({loader:false});
      })

    }
    
   
    
    formatDepartment=(group)=>{
      if(group && group.length) return group[0].name;
      return "";
    }
    
    //Search fn
    filterData = (e)=>{
      const key = e.target.value;
      let ar=[];
      this.state.fullData.forEach(element => {
        if(element.name.toLowerCase().indexOf(key.toLowerCase())>-1) 
        ar.push(element);
      });
      this.setState({data : ar})
    }
    
      render() {
        
        return (
          <div>
          <Loader loading={this.state.loader}></Loader>    
          <div className='bread-crumb overflow-auto'>
          <div>
          <span className='breadcrumb-title'>
            <input type='button' className='btn' value='Home - My Team'></input>
            

          </span>
         
          </div>
          </div>
          <div className='data-table-holder'>
            <div className='table-search-box'>
            <input type='text' placeholder="Search Here.." className='form-control' onChange={(e)=>this.filterData(e)}></input>
            </div>
            <div className='color-ind'>
                <div className='c'></div><span>Completed</span>
                <div className='p'></div><span>Pending</span>
                <div className='o'></div><span>Overdue</span>
            </div>
          <DataTable subHeaderAlign="center"
          columns={this.columns}
          data={this.state.data} pagination striped
         
          />
          </div>
          </div>
        )
      }
}
